import React from 'react'

import Icon from '../Icon2'
import PillIcon from '../Pills/PillIcon'
import { Truncate } from '../Truncate/Truncate'

const CollapsiblePillValue: React.FC<any>  = (props) => {
    const { testId, testIdPrefix, leadingIcon, canTruncate, variant, handleClick, text, index, prefixIcon, prefixColor } = props

	return (
		<>
			<div className={`QueryPills__filter-pills-content`} data-test-id={testId}>
				<div className="Pill PillValue" data-test-id={`${testIdPrefix}-content`}>
					<div className="PillItem flex-center PillItem__label PillItem__default">
						{leadingIcon ? <PillIcon icon={leadingIcon} variant={variant} pillIconPosition="start" /> : null}
						{
                            prefixIcon ? (
                                <div className="PillItem__prefix-icon">
                                    <Icon icon={prefixIcon} version="v2" size="extraSmall" />
                                </div>
                            ) : prefixColor ? (
                                <div
                                    className="PillItem__prefix-color"
                                    style={{ backgroundColor: prefixColor }}
                                />
                            ) : null
						}
						<span
							className={`PillItem__text-content`}
						>
							{canTruncate ?
								<Truncate isResponsive truncateFrom='end' >{text}</Truncate>
								: text}
						</span>
						<div className={"PillIcon PillIcon__label--end flex-center"}>
							<Icon
								icon="CloseNoborder"
								version="v2"
								size="extraSmall"
								onClick={handleClick}
								testId={`${testId}-cancel`}
							/>
						</div>
					</div>
				</div>
			</div>
		</>
	)
}
export default CollapsiblePillValue